import { Alert } from "@mui/material";
import { WebStorageStateStore } from "oidc-client-ts";
import { PropsWithChildren, useContext } from "react";
import { AuthProvider as OidcAuthProvider } from "react-oidc-context";
import { useNavigate } from "react-router";
import { RuntimeConfigContext } from "../config/RuntimeConfigContext";
import { useTranslator } from "../i18n/translator";
import { AutomaticLogin } from "./AutomaticLogin.tsx";
import { RefetchQueriesOnTokenRenewal } from "./RefetchQueriesOnTokenRenewal.tsx";

const useIdpConfig = () => useContext(RuntimeConfigContext).idpConfig;

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const translate = useTranslator();
  const idpConfig = useIdpConfig();
  const navigate = useNavigate();

  if (!idpConfig.authority || !idpConfig.clientId) {
    return (
      <Alert severity="error">{translate("errorLoadingLoginConfig")}</Alert>
    );
  }

  return (
    <OidcAuthProvider
      authority={idpConfig.authority}
      client_id={idpConfig.clientId}
      redirect_uri={new URL("/callback", document.location.origin).toString()}
      response_type="code"
      automaticSilentRenew={true}
      onSigninCallback={() =>
        navigate({
          pathname: sessionStorage.getItem("original-location-pathname") ?? "/",
          hash: sessionStorage.getItem("original-location-hash") ?? undefined,
          search:
            sessionStorage.getItem("original-location-search") ?? undefined,
        })
      }
      userStore={new WebStorageStateStore({ store: window.localStorage })}
      scope="openid email profile"
    >
      <RefetchQueriesOnTokenRenewal />
      <AutomaticLogin>{children}</AutomaticLogin>
    </OidcAuthProvider>
  );
};
